
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tidal-dashboard/bot-vault",
      function () {
        return require("private-next-pages/tidal-dashboard/bot-vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tidal-dashboard/bot-vault"])
      });
    }
  